import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[scaleToFit]'
})
export class ScaleToFitDirective implements OnInit, OnDestroy {
    private resizeListener: any;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngOnInit() {
        // set the initial transform property on the element
        this.renderer.setStyle(this.el.nativeElement, 'transform', 'scale(1)');

        // add a listener to the window resize event
        this.resizeListener = this.renderer.listen('window', 'resize', () => {
            // calculate the scale factor based on the window width and element width
            const scale = Math.min(window.innerWidth / this.el.nativeElement.offsetWidth, 1);

            // set the new transform property on the element
            this.renderer.setStyle(this.el.nativeElement, 'transform', `scale(${scale})`);
        });
    }

    ngOnDestroy() {
        // remove the window resize event listener when the directive is destroyed
        this.resizeListener();
    }
}
